import TextSearch from 'components/PaidLanding/TextSearch';
import TextSearchList from 'lib/TextSearchList';
import { colors } from 'components/styles/variables';
import { trackPaidTextSearch } from 'lib/Tracking/PaidLandingPage';
import { ListItem } from 'types/TextSearch';

interface MobileModalProps {
  closeModal: () => void;
  fullList: TextSearchList;
}

function MobileModal({ closeModal, fullList }: MobileModalProps): JSX.Element {
  return (
    <div className="mobile-modal-container">
      <div className="text-search-outer">
        <TextSearch
          closeModal={closeModal}
          openModal={(): void => {}}
          fullList={fullList}
          isModal={true}
          onSearchFieldSubmit={(item: ListItem): void => trackPaidTextSearch(item.searchParams)}
        />
      </div>

      <style jsx>{`
        .mobile-modal-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: white;
          z-index: 601;
          overflow: hidden;
        }

        .text-search-outer {
          padding: 16px;
          border-bottom: 1px solid ${colors.G2};
          position: fixed;
          width: 100%;
        }
      `}</style>
    </div>
  );
}

export default MobileModal;
